import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import currecyFormater from 'currency-formatter'
import * as popUp from '../toastr'
import GeneralServices from '../../app/service/generalServices'
import TableFilters from '../tableFilters'
import TransactionService from '../../app/service/estoque/transactionService'
import ConstantsUtil from '../../context/constantsUtil'
import HandleErrorService from '../../app/service/handleErrorService'
// import NFService from '../../app/service/estoque/NFService'
import ConfirmationDialog from '../confirmationDialog'
import TooltipButton from '../tooltipButton'
import { Dialog } from 'primereact/dialog'
import EditProvisaoDialog from '../contasAPagar/provisoes/editProvisaoDialog'
import { ProgressSpinner } from 'primereact/progressspinner'
import NfseService from '../../app/service/nfse/NfseService'
import AuthService from '../../app/service/authService'
import CheckNfseDialog from './checkNfseDialog'
import { Button } from 'primereact/button'

class NFseTable extends React.Component {

    state = {

        NFList: [],
        totalNFs: 0,

        filtro: {},
        firstInTable: ConstantsUtil.defaultFirstInTable,
        rowsInTable: ConstantsUtil.initialRowsInNFtable,
        // rowsInTable: 5,
        sortField: ConstantsUtil.defaultSortField,
        // sortField: "id",
        sortDirection: ConstantsUtil.sortDirectionDesc,
        // sortDirection: 'asc',
        pageIndex: 0,
        pageSize: ConstantsUtil.initialRowsInNFtable,
        // pageSize: 5,

        // selectedNFs: null,
        
        // expandedRows: [],
        current: null,
        
        NFToValidate: '',
        checkNFDialogVisible: false,

        NFToDelete: '',
        visibleConfirmDeleteNFDialog: false,

        NFToReativar: '',
        visibleConfirmReativarNFDialog: false,

        displayMotivoDialog: false,
        informacaoNFExcluida: {},

        totalValue: 0,
        
        // displayNFDevolucaoEntradaDialog: false,
        // notaFiscalDevolucaoReferencia: null,

        notaFiscalToEditProvisao: null,
        displayEditProvisaoDialog: false,

        loading: false,

        filtrosFromApi: {},

        // filterRequestId: null,

    }


    constructor(){
        super()
        this.dt = React.createRef()
        this.tableFilters = new TableFilters();
        this.transactionService = new TransactionService();
        this.NfseService = new NfseService();
        this.generalServices = new GeneralServices();

    }

    componentDidMount(){
        // if(this.props.validateNFs){
        //     this.searchNFsPendentes();
        // }

        // console.log("componentDidMount")
        
        this.filtraOcultaExcluidas()
        this.search()

    }

    filtraOcultaExcluidas = () => {
        let selectedSituacaoList = [ConstantsUtil.situacaoRegularAguardandoValidacaoLabel, ConstantsUtil.situacaoRegularValidadaLabel]
        this.setaSituacaoList(selectedSituacaoList)
    }

    setaSituacaoList = selectedSituacaoList => {
        this.setState({
            selectedSituacaoList,
            filtro: Object.assign(this.state.filtro, {selectedSituacaoList})
        })
    }

    valueBodyTemplate = (rowData) => {
        return currecyFormater.format(rowData.value, {locale: 'pt-BR'})
    }

    // hideDialog = () => {
    //     this.setState({checkNFDialogVisible: false})
    // }

    // delete = () => {
    //     if(this.state.selectedNFs){
    //         this.setState({displayDeleteConfirmation: true})
    //     } else {
    //         popUp.warningPopUp("Nenhuma nota foi selecionada para exclusão")
    //     }
    // }


    checkNF = (rowData) => {
        this.setState({checkNFDialogVisible: true})
        this.setState({NFToValidate: rowData})
    }

    validateNF = () => {
        // console.log("NFToValidate: ", this.state.NFToValidate)
        // var NFToValidate = this.state.NFToValidate
        // NFToValidate.dataHoraEntrada = `${NFToValidate.dataEntrada} - ${NFToValidate.horaEntrada}`

        this.NfseService.validateNF(this.state.NFToValidate)
        .then(async response => {
            popUp.successPopUp("Nota Fiscal validada com sucesso!")
            this.generalServices.sleep(500)
            window.location.reload()
            // await this.search()
            // await this.setState({NFToValidate: {}})
        }).catch(error => {
            HandleErrorService.handleError(error)
        })
        
    }    

    callExcluirNF = (rowData) => {
        this.setState({NFToDelete: rowData})
        this.setState({visibleConfirmDeleteNFDialog: true})
    }

    deleteNF = (motivoExclusao, gravarFrase) => {
        this.setState({loading: true})
        this.setState({visibleConfirmDeleteNFDialog: false})
        this.state.NFToDelete.motivoExclusao = motivoExclusao
        this.NfseService.deleteNF(this.state.NFToDelete, gravarFrase)
        .then(async response => {
            popUp.successPopUp("Nota Fiscal de Serviço excluída com sucesso!")
            // if(this.props.validateNFs){
            await this.search()
            // }
            // else{
            //     await this.props.search()
            //     this.resetaFiltrosTable()
            // }
            await this.setState({NFToDelete: ''})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    resetaFiltrosTable = () => {
        this.setState({selectedDhEmiList: []})
        this.setState({selectedDataValidacaoList: []})
        this.setState({selectedDataCompetenciaList: []})
        this.setState({selectedNumeroList: []})
        this.setState({selectedPrestadorServicoList: []})
        this.setState({selectedServicoList: []})
        this.setState({selectedSituacaoList: []})
        this.setState({selectedCodigoVerificacaoList: []})
        this.setState({selectedValorBrutoList: []})
        this.setState({selectedValorLiquidoList: []})
        this.setState({filtro: {}})
        this.filtraOcultaExcluidas()
    }

    callRevalidarNF = (rowData) => {
        this.setState({visibleConfirmReativarNFDialog: true})
        this.setState({NFToReativar: rowData})
    }

    revalidarNF = () => {
        this.setState({loading: true})
        this.setState({visibleConfirmReativarNFDialog: false})
        this.NfseService.revalidarNF(this.state.NFToReativar)
        .then(async response => {
            popUp.successPopUp("Nota Fiscal reativada com sucesso!")
            await this.resetaFiltrosTable()
            await this.search()
            await this.setState({NFToReativar: ''})
        }).catch(error => {
            // console.log("error: ", error)
            HandleErrorService.handleError(error)
        }).finally(() => {
            this.setState({loading: false})
        })
    }

    // handleRowToggle = (e) => {
    //     this.setState({expandedRows: e.data})
    //     if(!this.state.current) {
    //         this.setState({current: this.dt.current})
    //     }
    //     if(!this.dt.current) {
    //         this.dt.current = this.state.current
    //     }
    // }

    // calculateQuantidadeAndValorTotal = (currentTableValue) => {
    //     // console.log("calculateQuantidadeAndValorTotal: ", currentTableValue)
    //     if(this.props.setInfo){
    //         let quantidade = 0;
    //         if(this.props.quantidadeNotas){
    //             quantidade = this.props.quantidadeNotas
    //         }
    //         else{
    //             quantidade = currentTableValue ? currentTableValue.length : 0
    //         }
            
    //         let valorTotal = 0
    //         if(currentTableValue){
    //             currentTableValue.forEach(item => valorTotal+= item.valorTotal)
    //         }
    
    //         this.props.setInfo({quantidade, valorTotal})
    //     }

    //     if(this.props.onTableFilter){
    //         this.props.onTableFilter(currentTableValue)
    //     }

    // }

    searchByNumero = () => {

        this.setState({loading: true})

        this.NfseService.searchByNumero(this.props.numeroNFToSearch)
        .then(response => {
            this.trataDados(response.data);
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
            // AuthService.stopBlockUi()
        })

    }

    search = () => {

        if(this.props.isSearchByNumero){
            this.searchByNumero()
            return
        }

        let filtro = this.state.filtro
        if(this.props.validateNFs){
            filtro.pendenteValidacao = true
        }
        if(this.props.filtro){
            filtro = Object.assign(filtro, this.props.filtro)
        }

        let pageIndex = this.state.pageIndex
        let pageSize = this.state.pageSize
        let sortField = this.state.sortField
        let sortDirection = this.state.sortDirection

        const pageIndexToUse = pageIndex ? pageIndex : 0
        const pageSizeToUse = pageSize ? pageSize : ConstantsUtil.initialRowsInNFtable
        const sortFieldToUse = sortField ? sortField :
            (this.state.selectedFiltrarPor === ConstantsUtil.filtroDataEmissaoLabel ? 'dhEmi' : 'dhEmi')
        const sortDirectionToUse = sortDirection ? sortDirection : ConstantsUtil.sortDirectionDesc

        // AuthService.startBlockUi()
        this.setState({loading: true})

        this.buscaFiltros(filtro)

        this.NfseService.search(filtro, pageIndexToUse, pageSizeToUse, sortFieldToUse, sortDirectionToUse)
        .then(response => {
            this.trataDados(response.data);
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
            // AuthService.stopBlockUi()
        })        

    }

    trataDados = (responseData) => {
        responseData.nfseList.forEach(nfse => {
            GeneralServices.trataSituacaoNF(nfse)
        })

        this.setState({NFList: responseData.nfseList})
        this.setState({totalNFs: responseData.total})
        this.setState({totalValue: responseData.valorTotal})

        // let situacoesRetornadasList = nfseList.map(nfse => nfse.situacaoLabel)
        // let situacoesFiltradasRetornadas = []
        // this.state.selectedSituacaoList.forEach(selectedSituacao => {
        //     if(situacoesRetornadasList.includes(selectedSituacao)){
        //         situacoesFiltradasRetornadas.push(selectedSituacao)
        //     }
        // })
        // this.setaSituacaoList(situacoesFiltradasRetornadas)
    }

    buscaFiltros = (filtro) => {
        this.NfseService.buscaFiltros(filtro)
        .then(response => {
            // console.log("filtros: ", response.data)
            this.setState({filtrosFromApi: response.data})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    onPage = async event => {
        // console.log("onPage: ", event)

        await this.setState({
            firstInTable: event.first,
            rowsInTable: event.rows,
            pageIndex: event.page,
            pageSize: event.rows
        })
        
        this.search()

        // let pageIndex = event.page
        // let pageSize = event.rows
        // if(this.props.researchOnPage){
        //     this.props.researchOnPage(event)
        // }
    }

    onSort = event => {
        // console.log("onSort: ", event)
        // if(this.props.researchOnSort){
        //     this.props.researchOnSort(event)
        // }
    }

    onFilter = async event => {
        // console.log("onFilter: ", event)
        let filtro = this.state.filtro
        filtro[event.target.name] = event.target.value
        this.setState({filtro})
        // console.log("filtro final: ", this.state.filtro)
        this.search()
        // if(this.props.onFilter){
        //     this.props.onFilter(event)
        // }

    }

    hidePesquisaNumeroDialog = () => {
        this.setState({pesquisaNumeroDialogVisible: false})
        // this.setState({inputSearchValueErrorClass: ''})
        // this.setState({errorSearchValueMessage: ''})
    }

    openMotivoDialog = async (rowData) => {
        this.NfseService.verificaInformacoesDelecao(rowData.id)
        .then(async response => {
            await this.setState({displayMotivoDialog: true})
            await this.setState({informacaoNFExcluida: response.data})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    hideMotivoDialog = () => {
        this.setState({displayMotivoDialog: false})
        this.setState({informacaoNFExcluida: ''})
    }

    editProvisao = async notaFiscal => {
        
        if(notaFiscal.tipo === ConstantsUtil.saidaLabel){
            popUp.infoPopUp("Nota Fiscal de Saída não possui pagamento.")
            return;
        }

        //Verifica se é NF de Devolução de Entrada. Não possui provisão de pagamento.
        if(notaFiscal.tipo === ConstantsUtil.tipoNFDevolucaoEntradaLabel){
            popUp.infoPopUp("Nota Fiscal de Devolução de Entrada não possui pagamento.")
            return;
        }

        // Verifica se NF de Entrada com Bonificação Total. Se for, não possui provisão de pagamento.
        // this.NFService.isBonificacaoTotal(notaFiscal)
        // .then(async response => {
        //     if(response.data){
        //         //resposta veio true, ou seja, é bonificação total.
        //         popUp.infoPopUp("Nota Fiscal de Entrada com Bonificação total não possui pagamento.")
        //     }
        //     else{
        await this.setState({notaFiscalToEditProvisao: notaFiscal})
        this.setState({displayEditProvisaoDialog: true})
        //     }
        // })
        // .catch(error => {
        //     HandleErrorService.handleError(error)
        // })
    }

    hideEditProvisaoDialog = () => {
        this.setState({notaFiscalToEditProvisao: null})
        this.setState({displayEditProvisaoDialog: false})
    }

    // getQuantidadeNotas = () => {
    //     // console.log("this.props.quantidadeNotas: ", this.props.quantidadeNotas)
    //     // if(this.props.quantidadeNotas){
    //     //     return this.props.quantidadeNotas
    //     // }
    //     // else{
    //     //     return this.getList() ? this.getList().length : ''
    //     // }
    //     return 0
    // }

    // getInformacaoNFExcluida = () => {
    //     if(!this.state.informacaoNFExcluida){
    //         return ""
    //     }
    //     return `Motivo: ${this.state.informacaoNFExcluida.motivo}\n\nUsuário: ${this.state.informacaoNFExcluida.usuario}`
    // }

    render (){

        const renderMotivoDialog = () => {
            return (
                <Dialog
                    header={"Motivo da Exclusão da NF"}
                    visible={this.state.displayMotivoDialog}
                    modal
                    style={{ width: '50vw' }}
                    onHide={this.hideMotivoDialog}
                >

                    <div className="confirmation-content" >
                        <div
                            className='centraliza-conteudo-div-preserva-espaco-em-branco'
                        >
                            <strong>Motivo: </strong> {this.state.informacaoNFExcluida.motivo}
                        </div>

                        <div
                            className='centraliza-conteudo-div-preserva-espaco-em-branco'
                            style={{marginBottom: '10px'}}
                        >
                            <strong>Usuário: </strong> {this.state.informacaoNFExcluida.usuario}
                        </div>
                        
                    </div>
        
                </Dialog>                 
            )
        }

        const dhEmiFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.state.selectedDhEmiList,
            this.state.filtrosFromApi.dataEmissaoSemHorarioFiltroList,
            "selectedDhEmiList",
            (name, value) => this.setState({[name]: value}),
            this.onFilter,
            "Data Emissão"
        )

        const dataValidacaoFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.state.selectedDataValidacaoList,
            this.state.filtrosFromApi.dataValidacaoSemHorarioFiltroList,
            "selectedDataValidacaoList",
            (name, value) => this.setState({[name]: value}),
            this.onFilter,
            "Data Validação"
        )

        const dataCompetenciaFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.state.selectedDataCompetenciaList,
            this.state.filtrosFromApi.dataCompetenciaSemHorarioFiltroList,
            "selectedDataCompetenciaList",
            (name, value) => this.setState({[name]: value}),
            this.onFilter,
            "Data Competência"
        )

        const numeroFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.state.selectedNumeroList,
            this.state.filtrosFromApi.numeroFiltroList,
            "selectedNumeroList",
            (name, value) => this.setState({[name]: value}),
            this.onFilter,
            "Número"
        )

        const prestadorServicoFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.state.selectedPrestadorServicoList,
            this.state.filtrosFromApi.prestadorServicoFiltroList,
            "selectedPrestadorServicoList",
            (name, value) => this.setState({[name]: value}),
            this.onFilter,
            "Prestador Serviço"
        )

        const servicoFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.state.selectedServicoList,
            this.state.filtrosFromApi.servicoFiltroList,
            "selectedServicoList",
            (name, value) => this.setState({[name]: value}),
            this.onFilter,
            "Serviço"
        )

        const situacaoFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.state.selectedSituacaoList,
            this.state.filtrosFromApi.situacaoFiltroList,
            "selectedSituacaoList",
            (name, value) => this.setState({[name]: value}),
            this.onFilter,
            "Situação"
        )

        const codigoVerificacaoFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.state.selectedCodigoVerificacaoList,
            this.state.filtrosFromApi.codigoVerificacaoFiltroList,
            "selectedCodigoVerificacaoList",
            (name, value) => this.setState({[name]: value}),
            this.onFilter,
            "Código Verificação"
        )

        const valorBrutoFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.state.selectedValorBrutoList,
            this.state.filtrosFromApi.valorBrutoFiltroList,
            "selectedValorBrutoList",
            (name, value) => this.setState({[name]: value}),
            this.onFilter,
            "Valor Bruto"
        )

        const valorLiquidoFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.state.selectedValorLiquidoList,
            this.state.filtrosFromApi.valorLiquidoFiltroList,
            "selectedValorLiquidoList",
            (name, value) => this.setState({[name]: value}),
            this.onFilter,
            "Valor Líquido"
        )
        
        const actionValidarNFButton = (rowData) => {
            if(this.props.validateNFs){
                return (
                    <TooltipButton
                        tooltip = "Validar NF"
                        icon="pi pi-check"
                        style={ {maxHeight: '25px', maxWidth: '25px'} }
                        onClick={() => this.checkNF(rowData)} 
                    />
                )
            }
        }

        const actionExcluirNFButton = (rowData) => {
            // console.log("rowData: ", rowData)
            if(
                this.props.validateNFs 
                || 
                (
                  rowData && rowData.situacao === ConstantsUtil.situacaoRegular
                ) 
            ){
                return (
                    <TooltipButton
                        tooltip = {`Excluir Nota Fiscal. \n Essa NF ainda constará no sistema, mas não promoverá nenhuma alteração em Ficha de Estoque e nem nos pagamentos.`}
                        tooltipOptions={{ position: 'top'}}
                        icon="pi pi-trash"
                        className="p-button-rounded p-button-danger p-mr-2"
                        style={ {maxHeight: '25px', maxWidth: '25px', marginLeft: '5px'} }
                        onClick={() => this.callExcluirNF(rowData)}
                    />
                )
            }
        }

        const actionRevalidarNFButton = (rowData) => {
            if(
                this.props.conferenciaNF
                && (rowData.tipo === ConstantsUtil.tipoNFEntradaLabel || rowData.tipo === ConstantsUtil.tipoNFDevolucaoEntradaLabel)
                && rowData.situacaoLabel !== ConstantsUtil.situacaoRegularAguardandoValidacaoLabel
            )
            {
                return (
                    <TooltipButton
                        tooltip = {`Revalidar Nota Fiscal. \n Essa NFSe voltará à tela de Validação.`}
                        icon="pi pi-undo"
                        style={ {maxHeight: '25px', maxWidth: '25px', marginLeft: '5px'} }
                        onClick={() => this.callRevalidarNF(rowData)} 
                    />
                )
            }
        }

        const actionBody = (rowData) => {
            const buttons = [
                actionValidarNFButton(rowData),
                actionExcluirNFButton(rowData),
                actionRevalidarNFButton(rowData),
            ];
        
            // Retorna null se nenhum botão for renderizado, caso contrário, retorna os botões
            for(let button of buttons){
                if(button !== undefined){
                    return buttons
                }
            }
            return null
        }

        const renderAcoesColumn = () => {
            // const actionButtons = actionBody()
            // if(actionButtons){
                return (
                    <Column header="Ações" body={actionBody}
                        style ={ {width: '90px'} }
                    />
                )
            // }
        }

        // const renderDataEntradaColumn = () => {
        //     if(this.props.tipoNF === ConstantsUtil.tipoNFEntradaLabel){
        //         return (
        //             <Column
        //                 header="Data Entrada"
        //                 field="dataEntradaSemHorario"
        //                 body={rowData => rowData.dataHoraEntrada ? rowData.dataHoraEntrada.substring(0, 21) : ''}
        //                 style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '30px' : '60px'} }
        //                 sortable={!this.props.isSearchByNumero}
        //                 sortField='dataEntradaJsDate'
        //                 //filter={!this.props.isSearchByNumero} filterElement={dataEntradaNFFilterElement}
        //             />
        //         )
        //     }
        // }

        const actionBodyProvisao = (notaFiscal) => {
            if(notaFiscal.situacaoLabel === ConstantsUtil.situacaoRegularValidadaLabel){
                return (
                    <React.Fragment>
                        <TooltipButton
                            tooltip='Dados de Pagamento'
                            tooltipOptions={{ position: 'right' }}
                            icon={<i className="pi pi-pencil" style={{fontSize: '1em'}}></i>}
                            onClick={() => this.editProvisao(notaFiscal)}
                            style={{maxHeight: '25px', maxWidth: '25px'}}
                        />
    
                    </React.Fragment>
                );
            }
        }

        const renderColunaDadosPagamentoNF = () => {
            if(!this.props.validateNFs && !this.props.simpleView){
                return (
                    <Column header="Dados de pagamento da NF" body={actionBodyProvisao}
                        style ={ {width: '5rem'} }
                    />
                )
            }
        }

        const renderPreHeader = () => {
            if(this.state.currentLabel === this.state.NFLabel){
                return (
                    <div className = "card mb-3">
                        <div className = "card-header d-flex justify-content-between align-items-center">
                            <Button
                                // label={`${this.getQuantidadeLabel()} ${this.state.quantidadeItems}` }
                                label={`Quantidade de Notas: ${this.state.totalNFs}` }
                            />

                        <div className="flex-grow-1 text-center">
                            {/* <Button
                                label="Filtrar"
                                icon="pi pi-filter"
                                onClick={this.researchOnFilter}
                            />
                            <Button
                                className='right-button p-button-danger'
                                label="Limpar Filtros"
                                icon="pi pi-times"
                                onClick={this.limparFiltros}
                            /> */}
                        </div>

                            <Button
                                className="p-button-success ml-auto"
                                label={'Valor Total Líquido: ' + GeneralServices.valueBodyTemplate(this.state.totalValue) }
                            />

                        </div>
                    </div>
                )
            }
        }


        return (
            <div className="">
            <div className="card">

                {renderPreHeader()}

                <DataTable
                    ref={this.dt}
                    value={this.state.NFList}
                    // value={[]}
                    className="p-datatable-sm small-font"
                    rowHover
                    // selection={this.state.selectedNFs}
                    // onSelectionChange={(e) => this.setState({selectedNFs: e.value})}
                    scrollable
                    scrollHeight={this.props.insideFichaDeEstoqueDetalhamento ? "300px" : "500px"}
                    loading={this.state.loading || this.props.loading}
                    emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                    // expandableRows={true}
                    // expandedRows = {this.state.expandedRows}
                    // onRowToggle={this.handleRowToggle}
                    // rowExpansionTemplate={rowExpansionTemplate}
                    // onValueChange={this.calculateQuantidadeAndValorTotal} //onFilter
                    onPage={this.onPage}
                    onSort={this.onSort}
                    sortField={this.state.sortField}
                    sortOrder={this.state.sortOrder}
                    // showGridlines
                    dataKey="id"
                    paginator
                    // rows={ConstantsUtil.initialTableQuantityOption}
                    // paginatorTemplate={GeneralServices.tablePaginatorSpecific(ConstantsUtil.initialRowsInNFtable, 50, 100)}
                    paginatorTemplate={GeneralServices.tablePaginatorSpecific(5, 10, 15)}
                    // last
                    // totalRecords={this.state.totalRecords}
                    lazy //para que sobrescrita de totalRecords funcione
                    // first={this.state.firstInTable}
                    first={this.state.firstInTable}
                    // rows={this.state.rowsInTable}
                    rows={this.state.rowsInTable}
                    totalRecords={this.state.totalNFs}
                    // currentPageReportTemplate={`Mostrando de {first} ao {last} de ${this.getQuantidadeNotas()} Notas Fiscais`}
                    currentPageReportTemplate={`Mostrando de {first} ao {last} de {totalRecords} Notas Fiscais`}
                >

                    {/* <Column
                        header="Id"
                        field="id"
                    /> */}

                    {renderColunaDadosPagamentoNF()}

                    <Column
                        header="Data de Emissão"
                        field="dhEmi"
                        filter={!this.props.isSearchByNumero} filterElement={dhEmiFilterElement}
                    />

                    <Column
                        header="Data de Validação"
                        field="dataHoraValidacao"
                        filter={!this.props.isSearchByNumero} filterElement={dataValidacaoFilterElement}
                    />

                    <Column
                        header="Data Competência"
                        field="dataHoraCompetencia"
                        filter={!this.props.isSearchByNumero} filterElement={dataCompetenciaFilterElement}
                    />

                    <Column
                        header="Número"
                        field="numero"
                        filter={!this.props.isSearchByNumero} filterElement={numeroFilterElement}
                    />

                    <Column
                        header="Código Verificação"
                        field="codigoVerificacao"
                        filter={!this.props.isSearchByNumero} filterElement={codigoVerificacaoFilterElement}
                    />                    

                    <Column
                        header="Prestador de Serviço"
                        field="prestadorServico.nome"
                        filter={!this.props.isSearchByNumero} filterElement={prestadorServicoFilterElement}
                        body={rowData => `${rowData.prestadorServico.nome} (${rowData.prestadorServico.cnpj})`}
                    />

                    <Column
                        header="Descrição Serviço"
                        field="servico"
                        filter={!this.props.isSearchByNumero} filterElement={servicoFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.servico, rowIndex)}
                    />

                    <Column
                        header="Situação"
                        field="situacaoLabel"
                        sortable
                        // style ={ {width: '30px'} }
                        filter={!this.props.isSearchByNumero} filterElement={situacaoFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderStyledSituacaoNF(
                            rowData.situacaoLabel,
                            rowIndex,
                            () => {this.openMotivoDialog(rowData)}
                        )}
                    />

                    <Column
                        header="Valor Bruto"
                        field="valorBruto"
                        filter={!this.props.isSearchByNumero} filterElement={valorBrutoFilterElement}
                        body={rowData => {
                            return(
                                <div className='right-align'>
                                    {GeneralServices.valueBodyTemplate(rowData.valorBruto)}
                                </div>
                            )
                        }}                        
                    />

                    <Column
                        header="Valor Líquido"
                        field="valorLiquido"
                        filter={!this.props.isSearchByNumero} filterElement={valorLiquidoFilterElement}
                        body={rowData => {
                            return(
                                <div className='right-align'>
                                    {GeneralServices.valueBodyTemplate(rowData.valorLiquido)}
                                </div>
                            )
                        }}
                    />

                    {renderAcoesColumn()}

                </DataTable>

                {renderMotivoDialog()}
                
                {/* {renderNFDevolucaoEntradaDialog()} */}

            </div>

            <CheckNfseDialog
                visible={this.state.checkNFDialogVisible}
                // hideDialog={this.hideDialog}
                register={false}
                NFToValidate={this.state.NFToValidate}
                save={this.validateNF}
                hideDialog={() => this.setState({checkNFDialogVisible: false})}
            />

            <ConfirmationDialog
                header={"Deletar Nota Fiscal"}
                visible={this.state.visibleConfirmDeleteNFDialog}
                confimationMessage="Deseja Deletar esta Nota Fiscal?"
                confirm={this.deleteNF}
                hide={() => this.setState({visibleConfirmDeleteNFDialog: false})}
                hasConfirmationMessage
                motivoDeleteNF
                tipoFrase={ConstantsUtil.tipoFraseMotivoExclusaoNFSE}
                placeholderConfirmationMessage="Motivo"
            />    

            <ConfirmationDialog
                header={"Reativar Nota Fiscal"}
                visible={this.state.visibleConfirmReativarNFDialog}
                confimationMessage="Deseja Revalidar esta Nota Fiscal?"
                confirm={this.revalidarNF}
                hide={() => this.setState({visibleConfirmReativarNFDialog: false})}
            />

            <EditProvisaoDialog
                visible={this.state.displayEditProvisaoDialog}
                // provisaoId={this.state.idProvsisaoToEdit}
                notaFiscal={this.state.notaFiscalToEditProvisao}
                search={this.search}
                startLoadingTable={this.props.startLoadingTable}
                finishLoadingTable={this.props.finishLoadingTable}
                hideDialog={this.hideEditProvisaoDialog}
                tipoNotaFiscal={ConstantsUtil.tipoNotaFiscalServico}
            />              

        </div>
        )
    }


}  

export default NFseTable